module.exports = __webpack_public_path__ + "static/media/Approvals.442afa5a.svg";